var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#008CE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7359 4.5022H6.64314L6.30452 6.39614L9.99564 6.40176C11.8131 6.40176 12.3525 7.06157 12.3351 8.15676C12.3272 8.71814 12.0825 9.66764 11.979 9.97364C11.6995 10.7949 11.1235 11.7298 8.96458 11.7269L5.37696 11.7247L5.03833 13.6209H9.12039C10.5598 13.6209 11.173 13.4527 11.8204 13.154C13.257 12.4914 14.1126 11.0722 14.4563 9.21989C14.9659 6.46364 14.3303 4.5022 10.7353 4.5022H10.7359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89145 8.88636C9.02476 8.33229 9.06695 8.11011 9.06695 8.11011H4.87857C3.80757 8.11011 3.65457 8.80761 3.55276 9.22948C3.41945 9.7813 3.37726 10.0063 3.37726 10.0063H7.5662C8.63663 10.0063 8.78963 9.30879 8.89145 8.88636Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.cca70921740efce27c5ac4758b276cce.svg";
export { ForwardRef as ReactComponent };